var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var CountersModel = GenericModel.extend(
{
    urlRoot : "/api/statistics/queues",
    id : null,
});

module.exports = CountersModel;